import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';



const SnackBar=(props)=>{
    return(
        <Snackbar anchorOrigin={{horizontal:'right',vertical:'top'}} open={props.open} autoHideDuration={6000} onClose={props.handleClose}>
        <Alert
          onClose={props.handleClose}
          severity={props.type}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {props.message}
        </Alert>
      </Snackbar>
    )
}


export default SnackBar;